export const ASSIGNEE_LIST = "ASSIGNEE_LIST";
export const CHANGE_ASSIGNEE = "CHANGE_ASSIGNEE";
export const ASSIGNEE = "ASSIGNEE"

